import script from "./SessionDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./SessionDeleteDialog.vue?vue&type=style&index=0&id=e194f774&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e194f774"]])

export default __exports__